import React, { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router'
import { ServerConnection } from './hooks/ServerConnection'
import { keepConnectionToTheServer } from './utils/keepConnectionToServer'
import NewVM from './components/NewVM'
import ReceiveAccessCode from './components/ReceiveAccessCode'
import ConfirmVMCreation from './components/ConfirmVMCreation'
import RequestAccessCode from './components/RequestAccessCode'
import MachinesList from './components/MachinesList'
import LoadVMPanelServerConfig from './components/LoadVMPanelServerConfig'
import { usePromise } from './hooks/promise'
import { GitlabAccessTokenContext } from './hooks/GitlabAccessToken'
import { TimeDifference } from './hooks/TimeDifference'


const App = () => {
    const [serverConnection, setServerConnection] = useState(null)
    const accessTokenState = useState<string>(() => localStorage.getItem("GitLabAccessToken"))
    const [serverTimeDiff] = usePromise(async () => {
        if(serverConnection !== null) {
            const serverTime = await serverConnection.serverTime()
            return Date.now() - serverTime
        }
    }, [serverConnection], null)

    useEffect(() => {
        const { close } = keepConnectionToTheServer((connection) => {
            setServerConnection(connection)
        })

        return close
    }, [])

    if (serverConnection === null || serverTimeDiff === null) {
        return <div />
    }

    return (
        <ServerConnection.Provider value={serverConnection}>
            <TimeDifference.Provider value={serverTimeDiff}>
                <GitlabAccessTokenContext.Provider value={accessTokenState}>
                    <LoadVMPanelServerConfig>                
                        <div className="h-screen max-w-screen">
                            <Routes>
                                <Route path='/new_vm' element={<NewVM />} />
                                <Route path='/request-access-code' element={<RequestAccessCode />} />
                                <Route path='/receive-access-code' element={<ReceiveAccessCode />} />
                                <Route path='/confirm-vm-creation' element={<ConfirmVMCreation />} />
                                <Route path='/' element={<MachinesList />} />
                            </Routes>
                        </div>
                    </LoadVMPanelServerConfig>
                </GitlabAccessTokenContext.Provider>
            </TimeDifference.Provider>
        </ServerConnection.Provider>
    )
}

export default App
